import Cookies from 'js-cookie';

/**
 * Check for a `features` cookie with comma separated features that need to be enabled.
 * @param flagName Name of the feature flag
 * @param internalOnly Should it be available for internal use only?
 * @returns boolean if it can be used
 */
export function featureFlagEnabled(flagName: string, internalOnly = false): boolean {
  const hostname = window.location.hostname;
  const isInternal = hostname.includes('tkhinfra.com') || hostname.includes('localhost');
  const featureCookie = Cookies.get('features') || '';
  const features = featureCookie.split(',');

  if (internalOnly && !isInternal) {
    return false;
  }

  return features.includes(flagName);
}
